<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="20" y="16" width="18" height="24" rx="3" fill="#F9B418" />
    <rect x="15" y="12" width="18" height="24" rx="3" fill="#107EB1" />
    <path
      d="M10 14 a4 4 0 0 1 4 -4 h14 v22 a2 2 0 0 1 -2 2 h-14 a2 2 0 0 1 -2 -2 z"
      fill="#093A5A"
    />
  </svg>
</template>
